import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { WeatherConstraintsDto } from 'types';

export const getTimestamps = async (
  locationId: number | null | undefined,
  snapshotId: number | null | undefined,
  constraints: WeatherConstraintsDto
): Promise<{ time: string }[] | undefined> => {
  if (
    locationId === null ||
    locationId === undefined ||
    locationId < 1 ||
    snapshotId === null ||
    snapshotId === undefined ||
    snapshotId < 1
  )
    return;
  const { data } = await axios.put(
    `/api/weather/timestamps/${locationId}/snapshot/${snapshotId}`,
    constraints
  );
  return data as { time: string }[];
};

type QueryFnType = typeof getTimestamps;

type UseTimestampsOptions = {
  locationId: number | null | undefined;
  snapshotId: number | null | undefined;
  constraints: WeatherConstraintsDto;
  config?: QueryConfig<QueryFnType>;
};

export const useTimestamps = ({
  locationId,
  snapshotId,
  constraints,
  config,
}: UseTimestampsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['timestamps', locationId, snapshotId, constraints],
    queryFn: () => getTimestamps(locationId, snapshotId, constraints),
  });
};
